import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail } from "lucide-react";
import { ASSETS } from "@/lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#1a1a1a] bg-[#080808]">
      <div className="container-rotta py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src={ASSETS.logoMark} alt="ROTTA" className="h-10 w-auto" />
            <div className="flex flex-col leading-none">
              <span className="font-display text-2xl tracking-wider text-white">ROTTA</span>
              <span className="text-[10px] tracking-[0.3em] text-[#C6A762]">VIVA A ESTRADA</span>
            </div>
          </div>
          <p className="text-[#B8B8B8] text-sm max-w-md leading-relaxed">
            A ROTTA conecta motociclistas às melhores estradas, destinos e experiências do Brasil.
            Trajetos verificados, cidades, pontos de interesse, eventos e conteúdo de quem realmente
            vive a estrada.
          </p>

          <div className="flex items-center gap-3 mt-6">
            <a href="https://www.instagram.com/ride.rotta/" target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-10 h-10 grid place-items-center rounded-full border border-[#2a2a2a] text-white/70 hover:text-[#C6A762] hover:border-[#C6A762] transition">
              <Instagram size={16} />
            </a>
            <a href="https://www.youtube.com/@Rotta_Ride" target="_blank" rel="noreferrer" data-testid="footer-youtube" aria-label="YouTube" className="w-10 h-10 grid place-items-center rounded-full border border-[#2a2a2a] text-white/70 hover:text-[#C6A762] hover:border-[#C6A762] transition">
              <Youtube size={16} />
            </a>
            <a href="mailto:ride.rotta@gmail.com" data-testid="footer-email" aria-label="Email" className="w-10 h-10 grid place-items-center rounded-full border border-[#2a2a2a] text-white/70 hover:text-[#C6A762] hover:border-[#C6A762] transition">
              <Mail size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display tracking-wider text-white text-sm mb-5 uppercase">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/rotas" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Rotas</Link></li>
            <li><Link to="/cidades" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Cidades</Link></li>
            <li><Link to="/eventos" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Eventos</Link></li>
            <li><Link to="/blog" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Blog</Link></li>
            <li><Link to="/parcerias" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Parcerias</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display tracking-wider text-white text-sm mb-5 uppercase">Comunidade</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/sobre" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Sobre a ROTTA</Link></li>
            <li><Link to="/parcerias" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Parcerias</Link></li>
            <li><Link to="/#newsletter" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Newsletter</Link></li>
            <li><a href="https://www.instagram.com/ride.rotta/" target="_blank" rel="noreferrer" className="text-[#B8B8B8] hover:text-[#C6A762] transition">Instagram</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1a1a1a]">
        <div className="container-rotta py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#6e6e6e]">
          <span>© {new Date().getFullYear()} ROTTA — Viva a Estrada. Todos os direitos reservados.</span>
          <span className="tracking-[0.3em] uppercase">Liberdade · Aventura · Conexão</span>
        </div>
      </div>
    </footer>
  );
}
